/*!
 *
 * senior.js
 *
 */

module.exports = [
	{
		"name": "余田　泰征",
		"id": "yoden",
		"year": "2015年",
		"department": "阪神電気鉄道(株)<br>都市交通事業本部<br>運輸部企画課",
		"content": "運輸",
		"year": 1,
		"affili": 1,
		"kind": 1
	}, {
		"name": "小片　謙太",
		"id": "ogata",
		"year": "2014年",
		"department": "阪神電気鉄道(株)<br>都市交通事業本部<br>電気部電力課",
		"content": "鉄道技術(電気)",
		"year": 2,
		"affili": 1,
		"kind": 2
	}, {
		"name": "福井　伸行",
		"id": "fukui",
		"year": "2001年",
		"department": "阪神電気鉄道(株)<br>都市交通事業本部<br>車両部車両課",
		"content": "鉄道技術(車両)",
		"year": 3,
		"affili": 1,
		"kind": 2
	}, {
		"name": "樋口　大介",
		"id": "higuchi",
		"year": "2005年",
		"department": "阪急電鉄(株)<br>都市交通事業本部<br>都市交通計画部",
		"content": "鉄道技術(建築)",
		"year": 3,
		"affili": 1,
		"kind": 2
	}, {
		"name": "矢野　賢",
		"id": "yano",
		"year": "2014年",
		"department": "阪急電鉄(株)<br>都市交通事業本部　技術部<br>土木技術担当",
		"content": "鉄道技術(土木)",
		"year": 2,
		"affili": 1,
		"kind": 2
	}, {
		"name": "田原　理衣",
		"id": "tahara",
		"year": "2015年",
		"department": "(株)阪急スタイルレーベルズ<br>営業部　営業企画担当",
		"content": "流通",
		"year": 1,
		"affili": 1,
		"kind": 1
	}, {
		"name": "江島　周一郎",
		"id": "ejima",
		"year": "2009年",
		"department": "阪急電鉄(株)<br>都市交通事業本部 運輸部<br>営業担当",
		"content": "運輸",
		"year": 3,
		"affili": 1,
		"kind": 1
	}, {
		"name": "西岡　香里",
		"id": "nishioka",
		"year": "1999年",
		"department": "阪急阪神ビルマネジメント(株)<br>販売促進部",
		"content": "販売促進",
		"year": 3,
		"affili": 2,
		"kind": 2
	}, {
		"name": "中野　草太",
		"id": "nakano",
		"year": "2016年",
		"department": "阪急阪神不動産(株)<br>開発推進部<br>開発グループ",
		"content": "不動産",
		"year": 1,
		"affili": 2,
		"kind": 1
	}, {
		"name": "菅　千遥",
		"id": "suga",
		"year": "2013年",
		"department": "阪急阪神不動産(株)<br>都市マネジメント事業部<br>梅田まちづくりグループ",
		"content": "エリアマネジメント",
		"year": 2,
		"affili": 2,
		"kind": 1
	}, {
		"name": "山塙　哲史",
		"id": "yamabana",
		"year": "2009年",
		"department": "阪急阪神不動産(株)<br>首都圏開発事業部",
		"content": "首都圏",
		"year": 3,
		"affili": 2,
		"kind": 2
	}, {
		"name": "高平　幸子",
		"id": "takahira",
		"year": "2015年",
		"department": "阪急阪神不動産(株)<br>マンション事業部<br>品質管理グループ",
		"content": "住宅",
		"year": 1,
		"affili": 2,
		"kind": 2
	}, {
		"name": "東　春佑",
		"id": "azuma",
		"year": "2012年",
		"department": "阪神電気鉄道(株)<br>スポーツ・エンタテインメント事業本部<br>甲子園事業部",
		"content": "甲子園",
		"year": 2,
		"affili": 3,
		"kind": 1
	}, {
		"name": "田中　達也",
		"id": "tanaka",
		"year": "2012年",
		"department": "(株)阪神タイガース",
		"content": "エンタメ",
		"year": 2,
		"affili": 3,
		"kind": 1
	}, {
		"name": "西下　宏平",
		"id": "nishishita",
		"year": "2013年",
		"department": "(株)ベイ・コミュニケーションズ<br>技術部",
		"content": "CM",
		"year": 2,
		"affili": 5,
		"kind": 2
	}, {
		"name": "木村　卓哉",
		"id": "kimura",
		"year": "2014年",
		"department": "阪急電鉄(株)<br>創遊事業本部　歌劇事業部<br>東京事業担当",
		"content": "宝塚",
		"year": 2,
		"affili": 3,
		"kind": 1
	}, {
		"name": "竹上　直子",
		"id": "takegami",
		"year": "1993年",
		"department": "(株)梅田芸術劇場<br>経営管理部 兼 企画営業部",
		"content": "宝塚",
		"year": 3,
		"affili": 3,
		"kind": 1
	}, {
		"name": "伊藤　奈緒",
		"id": "ikeda",
		"year": "2014年",
		"department": "阪神電気鉄道(株)<br>総務部 法務担当",
		"content": "法務",
		"year": 2,
		"affili": 4,
		"kind": 1
	}, {
		"name": "西村　萌子",
		"id": "nishimura",
		"year": "2012年",
		"department": "阪神電気鉄道(株)<br>経営企画室<br>グループ営業推進・ＩＴ推進担当",
		"content": "グループ営業推進",
		"year": 2,
		"affili": 4,
		"kind": 1
	}, {
		"name": "原　巧憲",
		"id": "hara",
		"year": "2016年",
		"department": "(株)阪急阪神ビジネスアソシエイト<br>経理事業部",
		"content": "経理",
		"year": 1,
		"affili": 4,
		"kind": 2
	}, {
		"name": "金田　順",
		"id": "kanata",
		"year": "2014年",
		"department": "アイテック阪急阪神(株)東京支社<br>社会インフラ事業本部<br>社会システム部",
		"content": "",
		"year": 2,
		"affili": 5,
		"kind": 2
	}, {
		"name": "谷野　早苗",
		"id": "tanino",
		"year": "2011年",
		"department": "阪神電気鉄道(株)<br>都市交通事業本部<br>工務部",
		"content": "",
		"year": 2,
		"affili": 1,
		"kind": 2
	}, {
		"name": "徳田　耕大",
		"id": "tokuda",
		"year": "2012年",
		"department": "阪急阪神不動産(株)<br>首都圏マンション事業部<br>販売グループ　販売担当",
		"content": "",
		"year": 2,
		"affili": 2,
		"kind": 1
	}, {
		"name": "淺田　葵",
		"id": "asada",
		"year": "2016年",
		"department": "阪急電鉄(株)<br>都市交通事業本部<br>運輸部",
		"content": "",
		"year": 1,
		"affili": 1,
		"kind": 1
	}
];


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/senior.js
// module id = 22
// module chunks = 0 1